import React, { useState, useEffect } from 'react';
import { FormGroup, Label, Input } from 'reactstrap';
import { useClient } from 'context/clientContext';
import { useAccessToken } from 'context/tokenConfig';
import { baseurl } from 'authConfig';
import { useHasChecked } from 'context/hasCheckedContext';

const ClientSelection = () => {
  const { setClient, setSelectedClient, selectedClientName, setSelectedClientName } = useClient();
  const { accessToken } = useAccessToken()
  const [selectedClientHere, setSelectedClientHere] = useState('');
  const [clientsAll, setClientsAll] = useState([])
  const { setHasChecked } = useHasChecked()

  const getClients = async () => {
    try {
      const url = `${baseurl}/GetAllClients`;
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${accessToken}`,
          'Content-Type': 'application/json',
        },
      });

      if (response.ok) {
        const data = await response.json();
        setClientsAll(data);
      } else {
        console.error('Failed to fetch document data', response.status);
      }
    } catch (error) {
      console.error("Error in getDocumentData:", error);
    }
  };

  useEffect(() => {
    if (accessToken) {
      getClients()
    }
  }, [accessToken]);

const handleClientChange = (event) => {
  const clientID = event.target.value;
  const clientName = clientsAll.find(c => String(c.clientID) === clientID)?.clientName || "";

  setSelectedClientHere(clientID);
  setSelectedClient(clientID);
  setSelectedClientName(clientName);
  setHasChecked(true);
};


  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", padding: "100px 50px 100px 50px" }}>
      <p style={{ fontSize: "20px" }}>
        Please select a client
      </p>
      <div style={{ backgroundColor: "white", padding: "20px 35px 8px 20px", border: "1px solid black", borderRadius: "15px"}}>
    
      <FormGroup tag="fieldset">

      <FormGroup check>
          <Label check style={{ fontSize: "20px" }}>
            <Input
              type="radio"
              name="clientRadio"
              value="0"
              checked={selectedClientHere === '0'}
              onChange={() => {
                setSelectedClientHere('0'); 
                setClient(0);
                setSelectedClient(0)
                setSelectedClientName("All Clients");
                setHasChecked(true)
              }}
            />
            All Clients
          </Label>
        </FormGroup>

        {clientsAll.map(client => (
          <FormGroup check key={client.clientID}>
            <Label check style={{ fontSize: "20px" }}>
              <Input
                type="radio"
                name="clientRadio"
                value={client.clientID}
                checked={selectedClientHere === String(client.clientID)}
                onChange={handleClientChange}
              />
              {client.clientName}
            </Label>
          </FormGroup>
        ))}
      </FormGroup>
      </div>
    </div>
  );
};

export default ClientSelection;
